program Locker_Editor_2;



{$R *.dres}

uses
  Vcl.Forms,
  WEBLib.Forms,
  LockerEditor2 in 'LockerEditor2.pas'{*.html},
  uLockerController in '..\LockerUtils\uLockerController.pas',
  uLockerDataStore in '..\LockerUtils\uLockerDataStore.pas',
  uLockerDataStore_JSON in '..\LockerUtils\uLockerDataStore_JSON.pas',
  uLockerDataStore_MySQL in '..\LockerUtils\uLockerDataStore_MySQL.pas',
  uButtonPanel in '..\LockerUtils\uButtonPanel.pas',
  uGridEditBlock in '..\LockerUtils\uGridEditBlock.pas',
  uLockerContracts in '..\LockerUtils\uLockerContracts.pas',
  uConstants in '..\LockerUtils\uConstants.pas',
  uLockerState in '..\LockerUtils\uLockerState.pas',
  uPipelineFields in '..\LockerUtils\uPipelineFields.pas',
  uLockerFieldBindings in '..\LockerUtils\uLockerFieldBindings.pas',
  uLockerControls in '..\LockerUtils\uLockerControls.pas',
  uStrLists in '..\LockerUtils\uStrLists.pas';

{$R *.res}

begin
  Application.Initialize;
  Application.MainFormOnTaskbar := True;
  Application.CreateForm(TLockerEditor2_form, LockerEditor2_form);
  Application.Run;
end.
